/**
 * MessageViewIcon - Icon button to view message in context panel
 */

import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { Visibility as VisibilityIcon } from '@mui/icons-material';

interface MessageViewIconProps {
  messageId: number;
  chatId: number;
  onViewMessage: (messageId: number, chatId: number) => void;
  size?: 'small' | 'medium';
}

const MessageViewIcon: React.FC<MessageViewIconProps> = ({
  messageId,
  chatId,
  onViewMessage,
  size = 'small',
}) => {
  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation(); // Prevent triggering parent click handlers
    onViewMessage(messageId, chatId);
  };

  return (
    <Tooltip title={`View message #${messageId} in context`} arrow>
      <IconButton
        size={size}
        onClick={handleClick}
        sx={{
          ml: 0.5,
          color: 'primary.main',
          '&:hover': {
            bgcolor: 'primary.light',
          },
        }}
      >
        <VisibilityIcon fontSize={size} />
      </IconButton>
    </Tooltip>
  );
};

export default MessageViewIcon;
